const context = 'orders'

export const FETCH_REVENUE_CENTER_ORDERS = `${context}/FETCH_REVENUE_CENTER_ORDERS`
export const FETCH_ORDERS = `${context}/FETCH_ORDERS`
